import type { AxiosInstance } from 'axios'

import { UpdateCompanyInputInterface } from '../../interfaces/company'

export const updateCompany = (api: AxiosInstance) => (
  companyId: string,
  companyDetail: UpdateCompanyInputInterface
) => api.put(`/v1.0/admin/companies/${companyId}`, companyDetail)
